<template>
  <div class="column egoEvent">
    <div class="inner-content">
      <div class="flag" v-if="event.sponsor.length">
        <div class="word-wrapper">
          {{ findBranch(event.sponsor, branches) }}
        </div>
      </div>
      <!-- has_detail 为 1 代表老数据 -->
      <div :class="event.has_detail?'is-disable':''" class="event-img">
        <template v-if="!(event.has_detail || event.status === 4)">
          <router-link :to="`/event/${event.id}`" target="_blank">
            <img :src="event.notice_image?formatImage(event.notice_image):defaultCover" alt="">
          </router-link>
        </template>
        <template v-else>
          <img :src="event.notice_image?formatImage(event.notice_image):defaultCover" alt="">
        </template>
      </div>
      <div class="event-info">
        <div style="height:104px;margin-bottom:20px">
          <h1>
            <span class="event-status" :class="{'past':Number(event[eventStatusKey])===3 || Number(event['status'])===4}">{{mapStatus[event[event.status === 4 ? 'status' : eventStatusKey]]}}</span>
            <p class="event-title" :class="(event.has_detail) ? 'is-disable' : ''">
              <template v-if="!(event.has_detail || event.status === 4)">
                <router-link :to="`/event/${event.id}`" target="_blank">
                  {{event.title}}
                </router-link>
              </template>
              <template v-else>
                {{event.title}}
              </template>
            </p>
          </h1>
          <p class="event-content" v-html="event.events_profile_html"></p>
        </div>
        <div class="solid-high">
          <p class="event-guests" v-if="event.share_guests && event.share_guests.length">
            <span class="event-guest">{{event.share_guests | joinShareGuests}}</span>
          </p>
          <div class="time-location">
            <p class="event-location" v-if="formatCity(event.city, event.province, event.country)">
              <span class="iconfont icon-dizhi2"></span>
              <span>{{formatCity(event.city, event.province, event.country)}}</span>
            </p>
            <p v-if="event.begin_time" class="event-time">
              <span class="iconfont icon-shijian2"></span>
              <span>{{event.begin_time | time}}</span>
            </p>
          </div>
        </div>
        <div :class="(event.has_detail || event.status === 4) ? 'past' : ''" class="submit-instance">
          <template v-if="!(event.has_detail || event.status === 4)">
            <router-link :to="`/event/${event.id}`" target="_blank">查看详情</router-link>
          </template>
          <template v-else>
            <a href="javascript:void(0)">查看详情</a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { areaData } from '@/config'
import VueTypes from 'vue-types'

export default {
  // events 表示每个卡片的信息
  // branches 表示event页面的主办方
  // pageInfo 表示表示分页信息
  props: {
    event: VueTypes.object,
    pageInfo: VueTypes.object,
    branches: VueTypes.array,
    eventStatusKey: VueTypes.string.def('status')
  },
  data () {
    return {
      mapStatus: {
        '4': '已取消',
        '3': '已结束',
        '2': '进行中',
        '1': '未开始'
      },
      defaultCover: 'https://static001-test.geekbang.org/resource/image/fa/09/fa90a3cf00ca34dfed620edba4430609.png'
    }
  },
  components: {},
  methods: {
    formatCity (city, province, country) {
      var c = {}
      if (areaData[province]) {
        c = areaData[province].childs.filter(c => c.id === Number(city))[0] || { name: '' }
      } else {
        c = { name: '' }
        for (let i in areaData) {
          if (areaData[i].childs) {
            for (let j in areaData[i].childs) {
              if (areaData[i].childs[j].id === Number(city)) {
                c = areaData[i].childs[j]
                break
              }
            }
          }
        }
      }
      var n = c.name
      if (n[n.length - 1] === '市') n = n.slice(0, n.length - 1)
      return n
    },
    findBranch ([...sponsor], branches = []) {
      // 确认是不是老数据
      // const sponsorId = [...sponsor]
      if (sponsor.filter(id => { return Number(id) === 0 }).length) return ''
      if (!branches.length || !sponsor.length) return ''

      let branchObj = {}
      var branchName = ''
      branches.forEach((item) => {
        branchObj[item.id] = item
      })

      sponsor.forEach(id => {
        // 通过 formatCity 找到名字的
        if (
          Number(id) !== 99999
        ) {
          const {
            city = '',
            province = '',
            country = ''
          } = branchObj[id]

          branchName += `${this.formatCity(city, province, country)}、`
        } else {
          branchName += `${branchObj[id].name}、`
        }
      })

      return branchName.substring(0, branchName.length - 1)
    },
    formatImage (url) {
      if (url.indexOf('static') > -1) {
        return `${url}?x-oss-process=image/resize,w_800`
      } else if (url.indexOf('cdn001') > -1) {
        return `${url}?imageView2/0/w/800`
      } else {
        return url
      }
    }
  },
  created () {},
  watch: {},
  computed: {
  },
  filters: {
    time (time) {
      var d = new Date(time * 1000)
      var format = d => d < 10 ? `0${d}` : d
      return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()} ${format(d.getHours())}:${format(d.getMinutes())}`
    },
    joinShareGuests (arr) {
      let names = []
      arr.forEach((item) => {
        names.push(item.name)
      })
      return names.join('、')
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/bulma/app.sass'

// 暂无活动
.warn-tip-container
  display: flex
  justify-content: center
  align-items: center
  width: 100%
  margin-top: 50px
  .warn-tip
    font-size: 18px
    color: $primary3

.column
  .inner-content
    background-color: #fff
    position: relative
    border-radius: 5px
    overflow: hidden
    .flag
      position: absolute
      top: 20px
      right: 0px
      z-index: 5
      color: #fff
      .triangle
        top: -10px
        right: 0
        position: absolute
        z-index: 80
        width: 0
        height: 0
        border: 5px solid #943708
        border-top-color: transparent
        border-right-color: transparent
      .word-wrapper
        line-height: 16px
        background-color: $primary3
        padding: 5px 10px 5px 16px
        border-top-left-radius: 20px
        border-bottom-left-radius: 20px
    .event-img
      width: 100%
      padding-bottom: 55.55%
      overflow: hidden
      border-bottom: 1px solid #ececec
      position: relative
      img
        cursor: pointer
        position: absolute
        width: 100%
        top: 50%
        transform: translateY(-50%)
        transition: all .3s ease
        &:hover
          transform: translateY(-50%) scale(1.2)
      &.is-disable:hover
        cursor: default
        img
          transform: translateY(-50%)
    .event-info
      padding: 24px 21px 24px
      color: #353535
      font-size: 14px

      h1
        font-weight: 600
        position: relative
        // height: 60px
        .event-status
          position: absolute
          box-sizing: border-box
          font-size: 15px
          margin-top: 1px
          padding: 1px 16px 0
          border: 1px solid $primary3
          border-radius: 3px
          color: $primary3
          &.past
            border-color: #B2B2B2
            color: #B2B2B2
        .event-title
          text-indent: 90px
          font-size: 18px
          line-height: 29px
          transition: all .3s ease
          +limit-line-numbers(2)
          a
            // color: $primary3
            color: #353535
            cursor: pointer
            &:hover
              color: $primary3
          &.is-disable:hover
            a
              color: rgba(53, 53, 53, 1)
              cursor: default
      .event-content
        font-size: 14px
        line-height: 22px
        height: 44px
        color: rgba(53,53,53,.6)
        margin-top: 8px
        // margin-bottom: 20px
        +limit-line-numbers(2)
      .solid-high
        height: 80px
        .event-guests
          display: flex
          flex-wrap: wrap
          height: 22px
          overflow: hidden
          .event-guest
            margin-right: 80px
            padding: 0px 15px
            padding-top: 1px
            line-height: 22px
            font-size: 14px
            background-color: rgba(215, 179, 117, .2)
            font-weight: 500
            color: #CCAC72
            border-radius: 3px
            +limit-line-numbers(1)
        .time-location
          display: flex
          align-items: center
          // flex-direction: column
          margin-top: 22px
          .iconfont
            color: #CCAC72
            margin-right: 4px
          .event-location
            margin-right: 18px
            word-break: break-all
            display: flex
            align-items: center
            .iconfont
              font-size: 16px
          .event-time
            word-break: break-all
            display: flex
            align-items: center
            .iconfont
              margin-right: 6px
              font-size: 13px
      .submit-instance
        padding: 10px 0 0
        text-align: center
        &.past
          a
            background-color: rgba(178,178,178,.5)
            cursor: default
            &:hover
              background-color: rgba(178,178,178,.5)
        +mobile
          flex-direction: column
          align-items: center
          padding: 42px 0 30px
        a
          display: block
          color: #fff
          font-size: 18px
          padding: 8px 0
          background-color: $primary3
          border-radius: 3px
          transition: all 0.3s ease
          &:hover
            background-color: #dfc291
          +mobile
            margin: 4px 0
        a:hover
          color: #fff
      .submit-end
        width: 95%
        margin: 0 auto
        +fullhd
          width: 80%
        .wrapper
          padding: 50px 0 30px
          text-align: center
          display: flex
          justify-content: space-between
          &.single-btn
            justify-content: center
          +mobile
            flex-direction: column
            align-items: center
            padding: 42px 0 30px
          a
            width: 146px
            padding: 10px 0px
            border: 1px solid #c4c4c4
            border-radius: 5px
            color: #c4c4c4
            transition: all 0.3s ease
            &.end
              cursor: default
            &.detail
              border-color: $primary3
              color: $primary3
            &.detail:hover
              // color:
            &.end:hover
              color: #c4c4c4
            +mobile
              margin: 4px 0
</style>
